import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkHttpClient } from '../utils/httpThunkClient'

// Thunks for API calls
export const getUserHierarchyAssignment = ThunkHttpClient.get(
  'userHierarchyAssignment/getByUser',
  (userId) => `user-hierarchy-assignment/user/${userId}`
)

export const getUserHierarchyIds = ThunkHttpClient.get(
  'userHierarchyAssignment/getHierarchyIds',
  (userId) => `user-hierarchy-assignment/user/${userId}/hierarchy-ids`
)

export const saveUserHierarchyAssignment = ThunkHttpClient.post(
  'userHierarchyAssignment/save',
  (body) => ({ url: 'user-hierarchy-assignment/save', body })
)

export const saveUserAssignments = ThunkHttpClient.post(
  'userHierarchyAssignment/saveUserAssignments',
  (body) => ({ url: 'user-hierarchy-assignment/save-user-assignments', body })
)

export const deleteUserHierarchyAssignment = ThunkHttpClient.delete(
  'userHierarchyAssignment/delete',
  (id) => `user-hierarchy-assignment/${id}`
)

export const deleteByUserId = ThunkHttpClient.delete(
  'userHierarchyAssignment/deleteByUser',
  (userId) => `user-hierarchy-assignment/user/${userId}`
)

// Define the initial state
const initialState: any = {
  assignment: null,
  hierarchyIds: [],
  loading: false,
  error: null,
}

export const userHierarchyAssignmentSlice = createSlice({
  name: 'userHierarchyAssignment',
  initialState,
  reducers: {
    clearAssignment: (state) => {
      state.assignment = null
      state.hierarchyIds = []
    },
  },
  extraReducers: (builder) => {
    // Get user assignment
    builder.addCase(getUserHierarchyAssignment.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(getUserHierarchyAssignment.fulfilled, (state, action) => {
      state.loading = false
      if (action.payload) {
        state.assignment = Array.isArray(action.payload) ? action.payload[0] : (action.payload.data || action.payload)
      } else {
        state.assignment = null
      }
    })
    builder.addCase(getUserHierarchyAssignment.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })

    // Get user hierarchy IDs
    builder.addCase(getUserHierarchyIds.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(getUserHierarchyIds.fulfilled, (state, action) => {
      state.loading = false
      if (action.payload) {
        state.hierarchyIds = Array.isArray(action.payload) ? action.payload : (action.payload.data || [])
      } else {
        state.hierarchyIds = []
      }
    })
    builder.addCase(getUserHierarchyIds.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })

    // Save assignment
    builder.addCase(saveUserHierarchyAssignment.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(saveUserHierarchyAssignment.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(saveUserHierarchyAssignment.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })

    // Save user assignments
    builder.addCase(saveUserAssignments.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(saveUserAssignments.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(saveUserAssignments.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })

    // Delete assignment
    builder.addCase(deleteUserHierarchyAssignment.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(deleteUserHierarchyAssignment.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(deleteUserHierarchyAssignment.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  },
})

export const { clearAssignment } = userHierarchyAssignmentSlice.actions
export default userHierarchyAssignmentSlice.reducer



